import { render, staticRenderFns } from "./PagedListMicrosites.vue?vue&type=template&id=76477b33&"
import script from "./PagedListMicrosites.vue?vue&type=script&lang=js&"
export * from "./PagedListMicrosites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports